// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationProvider\ApiCoordinationProvider.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Coordination, CoordinationData, CoordinationOptions } from 'data/models/Coordination';
import { CoordinationCard, CoordinationCardData, CoordinationCardOptions } from 'data/models/CoordinationCard';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { CoordinationEditingPolicy } from 'server/enums/CoordinationEditingPolicy';
import { CoordinationProviderCurrency } from 'server/enums/CoordinationProviderCurrency';

// CoordinationProviderData is the class that CoordinationProvider serializes to/from
export interface CoordinationProviderData {
    CoordinationId : number;
    ProviderId : number;
	
    CardsAsProvider : CoordinationCardData[] | null;
    Coordination : CoordinationData | null;
    Provider : OrganizationData | null;
	
    Currency : CoordinationProviderCurrency;
    DisplayOrder : number;
    EditingPolicy : CoordinationEditingPolicy;
}

// CoordinationProviderOptions is the class which may be passed to the CoordinationProvider constructor to define optional initial data values
export interface CoordinationProviderOptions {
    CoordinationId : number;
    ProviderId : number;
	
    CardsAsProvider? : CoordinationCardOptions[] | null;
    Coordination? : CoordinationOptions | null;
    Provider? : OrganizationOptions | null;
	
    Currency? : CoordinationProviderCurrency;
    DisplayOrder? : number;
    EditingPolicy? : CoordinationEditingPolicy;
}

export class CoordinationProvider {
    public CoordinationId : DataSignal<number>;
    public ProviderId : DataSignal<number>;
	
    public CardsAsProvider : SDataArray<CoordinationCard>;
    public Coordination : DataSignal<Coordination | null>;
    public Provider : DataSignal<Organization | null>;
	
    public Currency : DataSignal<CoordinationProviderCurrency>;
    public DisplayOrder : DataSignal<number>;
    public EditingPolicy : DataSignal<CoordinationEditingPolicy>;

    constructor();
    constructor(data : CoordinationProviderOptions);
    constructor(data: CoordinationProviderOptions | null = null) {
        this.CoordinationId = jsonableObservable(S.value<number>(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.ProviderId = jsonableObservable(S.value<number>(data && data.ProviderId !== undefined ? data.ProviderId : 0));
	    
        this.CardsAsProvider = SArray<CoordinationCard>([]);
        this.Coordination = S.value<Coordination | null>(null);
        this.Provider = S.value<Organization | null>(null);
	    
        this.Currency = jsonableObservable(S.value<CoordinationProviderCurrency>(data && data.Currency !== undefined ? data.Currency : 0));
        this.DisplayOrder = jsonableObservable(S.value<number>(data && data.DisplayOrder !== undefined ? data.DisplayOrder : 0));
        this.EditingPolicy = jsonableObservable(S.value<CoordinationEditingPolicy>(data && data.EditingPolicy !== undefined ? data.EditingPolicy : 0));
    }

    static key(obj : CoordinationProvider) {
        return obj.CoordinationId() + '\u2618' + obj.ProviderId();
    }
    
    static dataKey(obj : CoordinationProviderOptions) {
        return obj.CoordinationId + '\u2618' + obj.ProviderId;
    }

    static update(obj : CoordinationProvider, data : CoordinationProviderOptions) {
        S.freeze(() => {
            if (data.CoordinationId !== undefined) obj.CoordinationId(data.CoordinationId);
            if (data.ProviderId !== undefined) obj.ProviderId(data.ProviderId);
	        
	        
            if (data.Currency !== undefined) obj.Currency(data.Currency);
            if (data.DisplayOrder !== undefined) obj.DisplayOrder(data.DisplayOrder);
            if (data.EditingPolicy !== undefined) obj.EditingPolicy(data.EditingPolicy);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationProvider.ts